export default __webpack_public_path__ + "static/media/maker.d4de0f9b.png";